// @ts-check
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { newReferralsAcknowledged } from 'agent_portal/actions/NewReceivedReferralsActions';
import { Link } from 'react-router';
import styles from './ReferralNotification.module.scss';
import iconSrc from './new_referral_notification.svg';

class ReferralNotification extends Component {
  render() {
    const { newReferrals, dispatch } = this.props;

    if (newReferrals.length === 0) {
      return null;
    }

    return (
      <div className={styles.notification}>
        <div className={styles.icon_container}>
          <img src={iconSrc} alt="New Referral" />
        </div>
        <div className={styles.body}>
          {newReferrals.length === 1 ? (
            <Link to="/a/portal/referrals">New Referral</Link>
          ) : (
            <Link to="/a/portal/referrals">{newReferrals.length} New Referrals</Link>
          )}
          <br />
          <br />
          <button
            className="button is-link is-outlined"
            onClick={() => dispatch(newReferralsAcknowledged())}
          >
            Acknowledge
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  newReferrals: state.newReceivedReferrals,
});

export default connect(mapStateToProps)(ReferralNotification);
